import { Component, OnInit } from '@angular/core';
import { PlansData } from '../../../../../shared/common/classes';
import { fadeOutOnLeaveAnimation, fadeInOnEnterAnimation } from 'angular-animations';

@Component({
  selector: 'app-mdn-change-information',
  templateUrl: './mdn-change-information.component.html',
  styleUrls: ['./mdn-change-information.component.scss'],
  animations: [
    fadeInOnEnterAnimation(),
    fadeOutOnLeaveAnimation()
  ]
})
export class MdnChangeInformationComponent implements OnInit {
  public selectedPlan: PlansData | null;
  constructor() { }

  ngOnInit(): void {
  }

  public onPopOverKeepPlan(): void {
    history.back()
  }

}
